import { Component, Input, OnInit } from '@angular/core';
import { Familiares } from 'src/app/core/familiares';
import { Solucoes } from 'src/app/core/solucoes';
import { VulnerabilidadesFamiliar } from 'src/app/core/vulnerabilidades-familiar';
import { SolucaoService } from 'src/app/services/solucao/solucao.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { DataUtilService } from '../../../../services/commons/data-util.service';
import { SituacoesVulnerabilidade } from './../../../../core/situacoes-vulnerabilidade';
import { SituacaoVulnerabilidadeService } from './../../../../services/situacao-vulnerabilidade/situacao-vulnerabilidade.service';

@Component({
  selector: 'cadastrar-vulnerabilidade',
  templateUrl: './cadastrar-vulnerabilidade.component.html',
  styleUrls: ['./cadastrar-vulnerabilidade.component.css']
})
export class CadastrarVulnerabilidadeComponent implements OnInit {

  @Input() vulnerabilidade: VulnerabilidadesFamiliar = new VulnerabilidadesFamiliar();
  @Input() familiar: Familiares;

  situacaoVulnerabilidades: SituacoesVulnerabilidade[];
  solucoes: Solucoes[];

  constructor(private toastService: ToastService,
              private solucaoService: SolucaoService,
              private situacaoVulnerabilidadeService: SituacaoVulnerabilidadeService,
              private dataUtilService: DataUtilService) {
  }

  ngOnInit() {
    this.initObjetos();

    this.solucaoService.getAll().subscribe((solucoes: Solucoes[]) => {
      this.solucoes = solucoes;
    });

    this.situacaoVulnerabilidadeService.getAll().subscribe((situacaoVulnerabilidades: SituacoesVulnerabilidade[]) => {
      this.situacaoVulnerabilidades = situacaoVulnerabilidades.filter(s => !s.sigiloso);
    });

  }

  adicionar() {
    Object.assign(this.vulnerabilidade.familiar, this.familiar);

    delete this.vulnerabilidade.familiar.vulnerabilidades;

    this.familiar.vulnerabilidades.push(this.vulnerabilidade);
  }

  initObjetos() {
    this.vulnerabilidade = new VulnerabilidadesFamiliar();
    this.vulnerabilidade.situacoesVulnerabilidade = new SituacoesVulnerabilidade();
    this.vulnerabilidade.solucoes = new Solucoes();

    this.vulnerabilidade.familiar = new Familiares();
  }


  habilitaBotao(formulario): boolean {
    return Object.keys(formulario.controls).length &&
          (formulario.controls.dataIdentificacao.value !== undefined ||
           formulario.controls.dataSolucao.value !== undefined ||
           formulario.controls.situacoesVulnerabilidade.value !== undefined ||
           formulario.controls.solucoes.value !== undefined);
  }

  carregar(vulnerabilidade) {
    this.vulnerabilidade = vulnerabilidade;
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }
}
